import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

class OrgItem extends Component {
  constructor(props) {
    super(props);
    this._onClick = this._onClick.bind(this);
  }

  _onClick() {
    this.props.onItemClick(this.props.organization.id);
  }

  render() {
    return (
      <li>
        <a onClick={this._onClick}>
          {this.props.organization.name}
          </a>
      </li>
    );
  }
}

OrgItem.propTypes = {
  organization: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onItemClick: PropTypes.func.isRequired,
};


export default class ChooseOrg extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='login'>
        <header className='brand-name animated fadeInLeft'>
          <h3>Blue<span className='black-span'>HQ</span></h3>
          <h4>Powered by <img alt='BlueLabs' src='/assets/logo/bluelabs-full-med.png' height={45} /></h4>
        </header>
        <div id='org-container'>
          <h3>Choose an Organization</h3>
          <ul>
            {
              this.props.availableOrganizations.map(organization =>
                <OrgItem key={organization.id}
                  organization={organization}
                  onItemClick={this.props.onSelectOrganization}
                />
              )
            }
          </ul>
        </div>
      </div>
    );
  }
}

ChooseOrg.propTypes = {
  onSelectOrganization: PropTypes.func.isRequired,
  availableOrganizations: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
